import { Autorizaciones } from './../../../models/autorizaciones.model';
import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';

@Component({
    selector: "page-autorizaciones",
    templateUrl: "./autorizaciones.component.html",
    styleUrls: ["./autorizaciones.component.css"],
    providers: [FormService]
})

export class AutorizacionesComponent {
    public rows = [];
    public actualRow;
    public autorizaciones: Autorizaciones;
    public form;
    public matcher = new FormService();
    public numberForm;
    public encontrado;
    public esp;

    constructor() {
        this.form = new FormGroup({
            autorizacion1: new FormControl('', Validators.required),
            autorizacion2: new FormControl('', Validators.required),
            autorizacion3: new FormControl('', Validators.required),
            autorizacion4: new FormControl('', Validators.required),
            autorizacion5: new FormControl('', Validators.required),
            autorizacion6: new FormControl('', Validators.required),
            autorizacion7: new FormControl('', Validators.required),
            especificar: new FormControl('', Validators.required)
        })
        if (!JSON.parse(localStorage.getItem("autorizaciones"))) {
            localStorage.setItem("autorizaciones", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("autorizaciones"));
            this.form.controls['autorizacion1'].setValue(this.rows[0] ? this.rows[0].Art121 : false);
            this.form.controls['autorizacion2'].setValue(this.rows[0] ? this.rows[0].Art122 : false);
            this.form.controls['autorizacion3'].setValue(this.rows[0] ? this.rows[0].Art123 : false);
            this.form.controls['autorizacion4'].setValue(this.rows[0] ? this.rows[0].Art124 : false);
            this.form.controls['autorizacion5'].setValue(this.rows[0] ? this.rows[0].Art55 : false);
            this.form.controls['autorizacion6'].setValue(this.rows[0] ? this.rows[0].Art59 : false);
            this.form.controls['autorizacion7'].setValue(this.rows[0] ? this.rows[0].Otro : false);
            this.form.controls['especificar'].setValue(this.rows[0] ? this.rows[0].especificar : '');

        }

        this.autorizaciones = { Art121: '', Art122: '', Art123: '', Art124: '', Art55: '', Art59: '', Otro: '', especificar: '' };

        if (localStorage.getItem("form")) {
            this.numberForm = localStorage.getItem("form");
            if (this.numberForm == 2.5) {
                this.encontrado = true;
            }

        }

    }


    add_autorizacion() {

        if (this.form.value.autorizacion7) {
            this.esp = this.form.value.especificar
        } else {
            this.esp = ""
        }

        localStorage.setItem("autorizaciones", JSON.stringify([]));
        this.actualRow = localStorage.getItem("autorizaciones");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            'Art121': this.form.value.autorizacion1,
            'Art122': this.form.value.autorizacion2,
            'Art123': this.form.value.autorizacion3,
            'Art124': this.form.value.autorizacion4,
            'Art55': this.form.value.autorizacion5,
            'Art59': this.form.value.autorizacion6,
            'Otro': this.form.value.autorizacion7,
            'especificar': this.esp
        })
        localStorage.setItem("autorizaciones", JSON.stringify(this.rows));

    }

    delete_autorizacion(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("autorizaciones", JSON.stringify(this.rows));
            }
        }
    }

}